import OrientationPopOver from './OrientationPopOver'

export default OrientationPopOver
